<template>
  <div class="comp-fh-shortcut-batch">
    <div class="select-num-container">
      <span>已选:</span>
      <em class="select-num">{{ tableSelectIds?.length }}</em>
      <span class="select-num-total">/{{ tableDataLength }}</span>
    </div>
    <!-- 批量按钮及快捷按钮 -->
    <shortcut-btn v-if="showShortcutBtn && tableRowComputed.LOGIC_ROLE_PERMISSION && tableRowComputed.LOGIC_ROLE_PERMISSION == 1" :viewId="viewId" :tableDataLength="tableDataLength" :entityId="entity" :fieldsListAll="shortcutBtnPermission" :recordObj="tableRowComputed" :computedStatus="tableRowComputed.computedInfo?.status" @cb="shortcutBtnCb" @clearSelected="clearSelected"></shortcut-btn>
    <batch-btn v-if="showBatchBtn" :listFields="columnFieldList" :entityId="entity" :filterParams="filterParams" :fieldsListAll="batchBtnPermission" :selectIds="tableSelectIds" :bingDataList="bingDataList" :buttonShortcut="buttonShortcut" :viewId="viewId" :tableDataLength="tableDataLength" :checkLifeStatus="checkLifeStatus" @cb="batchBtnCb"></batch-btn>
    <!--清除按钮 -->
    <div class="clear-select-btn" @click="clearSelected">
      <qfei-icon-close-one-outlined />
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue';
import ShortcutBtn from '../fh-shortcut-batch/components/shortcut-btn/shortcut-btn.vue';
import BatchBtn from '../fh-shortcut-batch/components/batch-btn/batch-btn.vue';
import { QfeiIconCloseOneOutlined } from '@qfei-design/icons-vue';
console.log('1-开始创建组件-setup');
const data = reactive({});
const name = ref();
console.log(data, name);
const props = defineProps({
  showShortcutBtn: {
    type: Boolean,
    default: false
  },
  showBatchBtn: {
    type: Boolean,
    default: false
  },
  viewId: {
    type: String,
    default: ''
  },
  entity: {
    type: String,
    default: ''
  },
  filterParams: {
    type: Object,
    default: () => {}
  },
  // 表格数据
  tableData: {
    type: Array,
    default: () => []
  },
  tableSelectIds: {
    type: Array,
    default: () => []
  },
  // 表格数据长度
  tableDataLength: {
    type: Number,
    default: 0
  },
  // 表格列配置
  columnFieldList: {
    type: Array,
    default: () => []
  },
  // 表格行数据
  tableRow: {
    type: Object,
    default: () => {}
  },
  batchBtnPermission: {
    type: Array,
    default: () => []
  },
  shortcutBtnPermission: {
    type: Array,
    default: () => []
  },
  buttonShortcut: {
    type: Array,
    default: () => []
  },

  bingDataList: {
    type: Array,
    default: () => []
  },
  checkLifeStatus: {
    type: Function,
    default: null
  }
});
const emits = defineEmits(['clearSelected', 'shortcutBtnCb', 'batchBtnCb']);
const tableRowComputed = computed(() => ({ ...props.tableRow }));
const clearSelected = () => {
  emits('clearSelected');
};
const shortcutBtnCb = (params, type) => {
  emits('shortcutBtnCb', params, type);
};
const batchBtnCb = (params) => {
  emits('batchBtnCb', params);
};
</script>
<style scoped lang="less">
@import './fh-shortcut-batch.less';
</style>
